module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item6-f7c1f93eb5521efa9e82bd8c304d0358.svg";